// Thème Blanc/Vert partagé (accueil + pages univers). Préférence persistée, synchro inter-pages.
import { useEffect, useState } from "react";

const KEY = "aya_home_theme";

export function useHomeTheme() {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem(KEY) || "light"; } catch { return "light"; }
  });
  useEffect(() => {
    try { localStorage.setItem(KEY, theme); } catch { /* navigation privée */ }
    window.dispatchEvent(new CustomEvent("aya-home-theme", { detail: theme }));
  }, [theme]);
  useEffect(() => {
    const sync = (e) => setTheme(e.detail);
    window.addEventListener("aya-home-theme", sync);
    return () => window.removeEventListener("aya-home-theme", sync);
  }, []);
  return [theme, setTheme];
}

export function HomeThemeToggle({ theme, onChange }) {
  const light = theme === "light";
  return (
    <button
      data-testid="home-theme-toggle"
      role="switch"
      aria-checked={light}
      aria-label={light ? "Thème blanc actif — basculer vers le thème vert" : "Thème vert actif — basculer vers le thème blanc"}
      title={light ? "Mode Blanc (actif) → Vert" : "Mode Vert (actif) → Blanc"}
      onClick={() => onChange(light ? "green" : "light")}
      style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "4px 7px", borderRadius: 999, border: "1px solid var(--ah-border-strong, rgba(16,185,129,0.5))", background: "var(--ah-surface-elev, #06281A)", cursor: "pointer", boxShadow: "var(--ah-shadow, 0 5px 20px rgba(0,0,0,0.32))", flexShrink: 0 }}
    >
      <span aria-hidden="true" style={{ width: 13, height: 13, borderRadius: "50%", background: "#FFFFFF", border: "1px solid rgba(100,117,108,0.45)", boxShadow: light ? "0 0 0 2px #10B981" : "none", transition: "box-shadow .2s" }} />
      <span aria-hidden="true" style={{ width: 13, height: 13, borderRadius: "50%", background: "linear-gradient(135deg,#10B981,#0E7A4F)", boxShadow: !light ? "0 0 0 2px #D4AF37" : "none", transition: "box-shadow .2s" }} />
    </button>
  );
}
